var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"audience-list-item",on:{"click":function($event){return _vm.$emit('select-audience', _vm.audience)}}},[_c('span',{staticClass:"audience-id"},[_vm._v("#"+_vm._s(_vm.audience.id))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.audience.name))]),(_vm.notInTariff)?_c('NotInTariffTooltip'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }